export const ANGLE_RX_MEMBERPORTAL_URL = "http://rx.anglehealth.com"

export const SMITH_RX_MEMBERPORTAL_URL = "http://www.mysmithrx.com/"


